import { pick } from 'lodash';
import axios, { AxiosRequestConfig } from 'axios';

import { isAxiosError } from '~/utils/Axios';

interface FetchOptions {
  body: string;
  credentials: string;
  headers: Record<string, string>;
  method: AxiosRequestConfig['method'];
  url: string;
}

export function adapterAxios() {
  return async (url: string, opts: FetchOptions) => {
    try {
      const res = await axios(url, {
        data: opts.body,
        ...pick(opts, ['headers', 'method']),
      });

      return res.data;
    } catch (e) {
      if (isAxiosError(e) && e.response) {
        throw pick(e.response, ['status', 'statusText', 'data']);
      }

      throw e;
    }
  };
}
